export default __webpack_public_path__ + "static/media/check-off.35fd8c88.svg";